export default __webpack_public_path__ + "static/media/img_top_6.18e6b270.webp";